import { render, staticRenderFns } from "./VisualAnalysisChartBody.vue?vue&type=template&id=022f6719&"
import script from "./VisualAnalysisChartBody.vue?vue&type=script&lang=ts&"
export * from "./VisualAnalysisChartBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports